import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"
import { useHistory } from 'react-router-dom';

//Import images
import avatar3 from "../../../assets/images/users/avatar-3.jpg"
import avatar4 from "../../../assets/images/users/avatar-4.jpg"

//i18n
import { withTranslation } from "react-i18next"
import { Context } from "app-contexts/CommonContexts"
import { useContext } from "react"

const NotificationDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  const {
    notifications
  } = useContext(Context);


  const count = 8
  let history = useHistory();


  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon "
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-bell bx-tada" />
          <span className="badge bg-danger rounded-pill">
            {notifications.length}
          </span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0 dropdown-menu-end">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Notifications")} </h6>
              </Col>
              <div className="col-auto">
                <a className="small" onClick={e => {
                  history.push("/ViewAll")
                }}>
                  {" "}
                  View All
                </a>
              </div>
            </Row>
          </div>

          <SimpleBar style={{ height: "230px" }}>
            <Link
              to="/ViewAll"
              // onClick={e => {
              //   history.push("/ViewAll")
              // }}

              className="text-reset notification-item"
            >
              {/* <div className="media"> */}
              {/* <div className="avatar-xs me-3 container"> */}
              {notifications.map((records, key) => (

                <div className="row-fluid m-3 ">
                  <div className="col-1">
                    <span
                      className="avatar-title bg-primary rounded-circle font-size-4 "
                      style={{ height: "20px" }}
                    >
                      <i className="bx bx-note" />
                    </span>

                  </div>
                  <div className="col-12">
                    {records.notiMessage}
                  </div>
                  <hr />
                </div>

                // <div >
                //   <span
                //     className="avatar-title bg-primary rounded-circle font-size-4 "
                //     style={{ height: "20px" }}
                //   >
                //     <i className="bx bx-note" />
                //   </span>

                //   {records.notiMessage}
                //   <div style={{ paddingRight: "16rem" }}></div>


                // </div>
              ))}
              {/* </div> */}
              {/* </div> */}
            </Link>
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link
              to="#"
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              onClick={e => {
                history.push("/ViewAll")
              }}
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
              {props.t("View all")}{" "}
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default withTranslation()(NotificationDropdown)

NotificationDropdown.propTypes = {
  t: PropTypes.any,
}
